var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6_2)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_6_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.1637 10.3725C38.7028 8.65052 37.3494 7.29727 35.6273 6.83631C32.5092 6 20 6 20 6C20 6 7.49096 6 4.37274 6.83631C2.65065 7.29727 1.29734 8.65052 0.836354 10.3725C2.50352e-07 13.4906 0 20 0 20C0 20 2.50352e-07 26.5094 0.836354 29.6275C1.29734 31.3495 2.65065 32.7028 4.37274 33.1636C7.49096 34 20 34 20 34C20 34 32.5092 34 35.6273 33.1636C37.3494 32.7028 38.7028 31.3495 39.1637 29.6275C40.0001 26.5094 40.0001 20 40.0001 20C40.0001 20 39.9968 13.4906 39.1637 10.3725Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9962 25.9996L26.3881 20.0006L15.9962 14.0015V25.9996Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 28,
    fill: "white",
    transform: "translate(0 6)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_6_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 28,
    fill: "white",
    transform: "translate(0 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.926421d0acd42f3ab130d28ccaf0b0af.svg";
export { ForwardRef as ReactComponent };